import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M3.83333 6.49935C3.3731 6.49935 3 6.87245 3 7.33268C3 7.79292 3.3731 8.16602 3.83333 8.16602H8C8.46024 8.16602 8.83333 7.79292 8.83333 7.33268C8.83333 6.87245 8.46024 6.49935 8 6.49935H3.83333Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M3 10.666C3 10.2058 3.3731 9.83268 3.83333 9.83268H6.33333C6.79357 9.83268 7.16667 10.2058 7.16667 10.666C7.16667 11.1263 6.79357 11.4993 6.33333 11.4993H3.83333C3.3731 11.4993 3 11.1263 3 10.666Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.2917 2.33268H11.3333C12.714 2.33268 13.8333 3.45197 13.8333 4.83268V8.16602C13.8333 8.62625 13.4602 8.99935 13 8.99935C11.1591 8.99935 9.66667 10.4917 9.66667 12.3327C9.66667 14.1736 11.1591 15.666 13 15.666C13.4602 15.666 13.8333 16.0391 13.8333 16.4993C13.8333 16.9596 13.4602 17.3327 13 17.3327C12.9005 17.3327 12.8018 17.3298 12.7037 17.3241C12.6644 17.3297 12.6242 17.3327 12.5833 17.3327H3C1.61929 17.3327 0.5 16.2134 0.5 14.8327V4.83268C0.5 3.45197 1.61929 2.33268 3 2.33268H3.04167C3.2347 1.38175 4.07543 0.666016 5.08333 0.666016H9.25C10.2579 0.666016 11.0986 1.38175 11.2917 2.33268ZM3.41651 3.99935H3C2.53976 3.99935 2.16667 4.37245 2.16667 4.83268V14.8327C2.16667 15.2929 2.53976 15.666 3 15.666H9.27316C8.48142 14.7814 8 13.6133 8 12.3327C8 9.85519 9.80191 7.79855 12.1667 7.40181V4.83268C12.1667 4.37245 11.7936 3.99935 11.3333 3.99935H10.9168C10.5367 4.50537 9.93159 4.83268 9.25 4.83268H5.08333C4.40174 4.83268 3.7966 4.50537 3.41651 3.99935ZM4.66667 2.74935C4.66667 2.51923 4.85321 2.33268 5.08333 2.33268H9.25C9.48012 2.33268 9.66667 2.51923 9.66667 2.74935C9.66667 2.97947 9.48012 3.16602 9.25 3.16602H5.08333C4.85321 3.16602 4.66667 2.97947 4.66667 2.74935Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M12.6161 10.0573C12.9523 9.74296 13.4796 9.76073 13.7939 10.0969L15.2754 11.6817C15.5642 11.9906 15.5758 12.4668 15.3025 12.7895L13.821 14.538C13.5235 14.8892 12.9976 14.9327 12.6465 14.6351C12.2953 14.3376 12.2519 13.8118 12.5494 13.4606L12.8684 13.0841H11.3333C10.8731 13.0841 10.5 12.711 10.5 12.2508C10.5 11.7905 10.8731 11.4174 11.3333 11.4174H12.7469L12.5764 11.2351C12.2621 10.8989 12.2799 10.3716 12.6161 10.0573Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}